// extracted by mini-css-extract-plugin
module.exports = {"navigation":"episode-page_navigation__3fMbf","backBtn":"episode-page_backBtn__1P3Ok"};